const INSURANCE_UNIQUE_ID = {
  AVLA: '9c4e7a21-6f83-4d15-b2a9-8e7c1f3d5a60',
  AXA: '555b5249-1f74-4681-9f49-5958ad720cfb',
  ESSOR: '406fecd8-bfd7-4cba-a9bd-87efcfd38288',
  MITSUI_SUMITOMO: 'ff4a046b-d047-4bec-9253-1e3bc83c2df1',
  NEWE: 'd53bda2d-0710-4bff-b5be-51f2ab377362',
  SANCOR: '1f1fe992-d479-4a6c-9124-146d8c5f4631',
  SOMBRERO: '7e3b3e1a-e0db-4067-876f-350f73a38acd',
  JNS: '927ae810-4cdb-470a-8b93-03bdf2d2899a',
}

export default INSURANCE_UNIQUE_ID
